export default __webpack_public_path__ + "static/media/0000..0001.23f25b17.png";